import React from 'react';
import { takeEvery, put, call } from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import { addAccount } from 'Workspace/Admin/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { account, meta = {} } = action;
  const { additionalCallbacks = [] } = meta;
  const payload = {
    type: constants.RTM_IAM_SUBSCRIPTION_USER_PROVISION,
    honorificPrefix: account.honorificPrefix,
    givenName: account.givenName,
    familyName: account.familyName,
    email: account.email,
    password: account.password,
    roles: account.roles,
    ...(account.authenticationType != null && account.authenticationType !== '' && { authenticationType: account.authenticationType }),
    ...(account.region != null && account.region !== '' && { region: account.region }),
    ...(account.pearsonId != null && account.pearsonId !== '' && { pearsonId: account.pearsonId }),
  };
  try {
    const workspaceAccountCreate = yield call(connection.fetch.bind(connection), payload);

    if (workspaceAccountCreate.type === constants.RTM_IAM_SUBSCRIPTION_USER_PROVISION_OK) {
      const response = workspaceAccountCreate.response.account;
      yield put(addAccount(response));
    } else {
      yield put(
        pushToast({
          type: 'simple',
          message: <FormattedMessage {...messages.failedWorkspaceAccountCreate} />,
        })
      );
      additionalCallbacks.forEach((cb) => cb());
      return;
    }
  } catch (error) {
    throw error;
  }
  additionalCallbacks.forEach((cb) => cb());
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_ACCOUNT_CREATE, catchErrors, sendRequest, connection);
}
